/**
 * The club's contact details, in one place so every page shows the same.
 *
 * The Contact page and the order confirmation each had template filler
 * written in by hand: an address in another state, a placeholder email. Anything
 * that shows how to reach the club reads from here.
 */
const address = "2108 South Blvd, Charlotte NC 28203";

export const CSF_CONTACT = {
  phone: "980.318.2418",
  phoneHref: "tel:+19803182418",
  email: "info@carolinasoccerfactory.com",
  address,
  mapHref: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`,
};

// Mass email can go out as either brand. Keys match the backend's
// EMAIL_BRANDS (app/utils/company.py); the backend falls back to "csf".
export const EMAIL_BRANDS = {
  csf: {
    name: "Carolina Soccer Factory",
    email: CSF_CONTACT.email,
    website: "carolinasoccerfactory.com",
    logo: null,
  },
  flag_football: {
    name: "Carolina Flag Football Factory",
    email: "info@csfflag.com",
    website: null,
    logo: "/assets/brand/csf-flag-logo.png",
  },
};
